var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuPermission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.482,
    height: 16.487,
    viewBox: "0 0 16.482 16.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.75 -1.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_733",
    "data-name": "Ellipse 733",
    cx: 4.317,
    cy: 4.317,
    r: 4.317,
    transform: "translate(5.478 1.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10325",
    "data-name": "Path 10325",
    d: "M17.908,13.183H18.3a.981.981,0,0,1,.981.981v1.177a.589.589,0,1,0,1.177,0V14.164A2.159,2.159,0,0,0,18.3,12.006l-.043,0-.042,0h-.308a2.159,2.159,0,0,0-2.158,2.158v1.177a.589.589,0,1,0,1.177,0V14.164a.981.981,0,0,1,.981-.981Z",
    transform: "translate(-3.012 -2.26)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10326",
    "data-name": "Path 10326",
    d: "M11.406,20.151a2.143,2.143,0,0,1-.238-.986V16.418a2.152,2.152,0,0,1,.785-1.665v-.3a2.94,2.94,0,0,1,.147-.918,14.976,14.976,0,0,0-2.305-.176,11.68,11.68,0,0,0-6.349,1.629,3.36,3.36,0,0,0-1.7,2.687v1.138a1.333,1.333,0,0,0,1.334,1.334Z",
    transform: "translate(0 -2.552)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10327",
    "data-name": "Path 10327",
    d: "M21.029,19.627V16.88a1.374,1.374,0,0,0-1.374-1.374H16.124A1.374,1.374,0,0,0,14.75,16.88v2.747A1.374,1.374,0,0,0,16.124,21h3.532A1.374,1.374,0,0,0,21.029,19.627ZM17.3,17.861v.785a.589.589,0,1,0,1.177,0v-.785a.589.589,0,1,0-1.177,0Z",
    transform: "translate(-2.797 -3.013)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuPermission);
export default __webpack_public_path__ + "static/media/icon-menu-permission.806a939051ef275429c0a29cd9888ea2.svg";
export { ForwardRef as ReactComponent };